import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  computed,
  inject,
  signal,
} from '@angular/core';
import { AiGuideChatService } from '../../services/ai-guide-chat.service';

/**
 * Animated “Want some help?” FAB that opens the AI Tour-Guide sidebar.
 *
 * Mounts collapsed, expands after 900ms, stays labelled for 5s, then
 * collapses back to the circular logo. Hides while the sidebar is open.
 */
@Component({
  selector: 'app-launch-guide-button',
  imports: [],
  templateUrl: './launch-guide-button.html',
  styleUrl: './launch-guide-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LaunchGuideButton {
  private static readonly EXPAND_DELAY_MS = 900;
  private static readonly EXPANDED_DWELL_MS = 5000;

  private readonly aiGuideChatService = inject(AiGuideChatService);
  private readonly destroyRef = inject(DestroyRef);

  readonly expanded = signal(false);
  readonly hidden = computed(() => this.aiGuideChatService.isAiGuideOpen());

  constructor() {
    const timers: ReturnType<typeof setTimeout>[] = [];

    timers.push(
      setTimeout(() => {
        this.expanded.set(true);
        timers.push(
          setTimeout(
            () => this.expanded.set(false),
            LaunchGuideButton.EXPANDED_DWELL_MS,
          ),
        );
      }, LaunchGuideButton.EXPAND_DELAY_MS),
    );

    this.destroyRef.onDestroy(() => {
      for (const timer of timers) {
        clearTimeout(timer);
      }
    });
  }

  open(): void {
    this.aiGuideChatService.setAiGuideOpen(true);
  }
}
